import { deleteCashierBoxById, deleteCashierBoxMovementById } from "./cashierbox/delete";
import { getCashierBoxMovementsHistory, getCashierboxesById, getCashierboxesByStoreId } from "./cashierbox/get";
import { addCashierBoxMovement, createCashierBox } from "./cashierbox/post";
import { updateCashierBoxById, updateCashierBoxMovementById } from "./cashierbox/put";
import { getSubscriptionBillingStatus, getAvailableBillingExtraPackages, getAvailableSubscriptionPlans, getCFDIAddonStatus, getCompanyById, getCompanyOrdersMetrics, getGarmentAttributeCatalogs } from "./companies/get";
import { applyCatalogConsolidation, changeSubscriptionPlan, disableBillingOverage, disableCFDIAddon, enableBillingOverage, enableCFDIAddon, previewCatalogConsolidation, previewSubscriptionPlanChange, updateCFDIOrgLogo, updateCompanyTaxInfoCertificates } from "./companies/post";
import { updateCompanyById, updateCompanyLogoById, updateCompanySubscriptionBillingInfoById, updateCompanyTaxInfoById, updateGarmentAttributeCatalogsById } from "./companies/put";
import { getCountries } from "./countries/get";
import * as configEndpoints from "./config";
import { getAutomaticDiscountById, getAutomaticDiscounts, getAvailableAutomaticDiscounts, getDiscountCodeById, getDiscountCodes, verifyDiscountCode, verifyDiscountCodeCustomersApp } from './discounts/get';
import { createAutomaticDiscount, createDiscountCode } from "./discounts/post";
import { deleteAutomaticDiscountById, deleteDiscountCodeById, updateAutomaticDiscountById, updateDiscountCodeById } from "./discounts/put";
import { deleteStoreStaffById } from "./staff/delete";
import { getStoreAssignableStaffs, getStoreStaff, getStoreStaffById } from "./staff/get";
import { createStoreStaff } from "./staff/post";
import { updateStoreStaffById, updateStoreStaffStores } from "./staff/put";
import { getOrderSequence, getPaymentFees, getPickupScheduleCustomersApp, getStoreById, getStoreImages, getStoreReviewLink, getStores, getStoresByIdCustomersApp, getStoresByName } from "./stores/get";
import { copyLoyaltySettings, copyStore, createStore, createStoreImage } from "./stores/post";
import { deleteStoreById, setOrderSequence, updatePaymentFees, updateStoreById } from "./stores/put";
import { createCFDISuscrptionCheckoutSession, createCreateSuscriptionCheckoutSession, createCustomerPortalSession, createGetMoreCheckoutSession } from "./stripe/post";
import { deleteSupplyById } from "./supplies/delete";
import { getSupplies, getSupplyById, getSupplyHistory } from "./supplies/get";
import { createSupply } from "./supplies/post";
import { addSupplyStock, updateSupplyById } from "./supplies/put";
import { updatePushNotificationTokenDriversApp, updateUserById } from "./users/put";
import { getUserStoreAccess } from "./users/get";
import * as inventoryEndpoints from './inventory';
import * as sectionsEndpoints from './sections';
import * as productsEndpoints from './products';
import * as customersEndpoints from './customers';
import * as csvExportEndpoints from './csv';
import * as pdfExportEndpoints from './pdf';
import * as reportsExportEndpoints from './reports';
import * as ordersEndpoints from './order';
import * as authEndpoints from './auth';
import * as attendanceEndpoints from './attendance';
import * as routesEndpoints from './routes';
import * as reviewsEndpoints from './reviews';
import * as cfdiEndpoints from './cfdi';
import * as invoiceModuleEndpoints from './invoiceModule';
import * as cashupsEndpoints from './cashups';
import * as expensesEndpoints from './expenses';
import { deleteUserById } from "./users/delete";
import * as partnersEndpoints from './partners';
import * as outsourcedOrdersEndpoints from './outsourcedOrders';
import * as publicsEndpoints from './publics';
import { validateUserPin } from "./users/post";
import { getAxiosInstance } from "./axiosInstance";
import * as integrationsEndpoints from './integrations';
import * as updatesEndpoints from './updates';
import * as intercomEndpoints from './intercom';
import * as productFeedbackEndpoints from './productFeedback';
import * as productSurveysEndpoints from './productSurveys';
import * as googleMapsEndpoints from './googleMaps';
import * as websiteBuilderEndpoints from './websiteBuilder';
import * as companyMediaEndpoints from './companyMedia';
import { connectPublisher } from './customerDisplay';
function bindMethods(instance, methods) {
    const boundMethods = {};
    for (const key in methods) {
        const method = methods[key];
        if (Object.prototype.hasOwnProperty.call(methods, key) && typeof method === 'function') {
            boundMethods[key] = method.bind(instance);
        }
    }
    return boundMethods;
}
class WashdayClient {
    constructor(apiToken, env = 'PROD', clientId, clientSecret) {
        this.apiToken = apiToken;
        this.env = env;
        this.clientId = clientId;
        this.clientSecret = clientSecret;
        this.axiosInstance = this.axiosInstance ? this.axiosInstance : getAxiosInstance(env, this.clientId, this.clientSecret);
        this.customerDisplay = bindMethods(this, { connectPublisher });
        this.cashup = bindMethods(this, {
            getList: cashupsEndpoints.getModule.getList,
            getById: cashupsEndpoints.getModule.getById,
            getPreviewDataForCashClose: cashupsEndpoints.getModule.getPreviewDataForCashClose,
            create: cashupsEndpoints.postModule.create,
            deleteCashUpReport: cashupsEndpoints.deleteModule.deleteCashUpReport
        });
        this.expenses = bindMethods(this, {
            getList: expensesEndpoints.getModule.getList,
            exportList: expensesEndpoints.getModule.exportList,
            getById: expensesEndpoints.getModule.getById,
            create: expensesEndpoints.postModule.create,
            createFromMovement: expensesEndpoints.postModule.createFromMovement,
            linkCashierBoxMovement: expensesEndpoints.postModule.linkCashierBoxMovement,
            updateById: expensesEndpoints.putModule.updateById,
            deleteById: expensesEndpoints.deleteModule.deleteById,
        });
        this.cfdi = bindMethods(this, {
            getList: cfdiEndpoints.getModule.getList,
            downloadCFDIPDF: cfdiEndpoints.getModule.downloadCFDIPDF,
            downloadCFDIZIP: cfdiEndpoints.getModule.downloadCFDIZIP,
            sendCFDIByEmail: cfdiEndpoints.getModule.sendCFDIByEmail,
            getCFDIPreview: cfdiEndpoints.getModule.getCFDIPreview,
            getCFDIPreviewByOrderId: cfdiEndpoints.getModule.getCFDIPreviewByOrderId,
            createCFDI: cfdiEndpoints.postModule.createCFDI,
            createGlobalCFDI: cfdiEndpoints.postModule.createGlobalCFDI,
            searchGlobalByPaymentMethodCandidates: cfdiEndpoints.postModule.searchGlobalByPaymentMethodCandidates,
            previewGlobalByPaymentMethodCFDI: cfdiEndpoints.postModule.previewGlobalByPaymentMethodCFDI,
            createGlobalByPaymentMethodCFDI: cfdiEndpoints.postModule.createGlobalByPaymentMethodCFDI,
            cancelCFDI: cfdiEndpoints.deleteModule.cancelCFDI
        });
        this.invoiceModule = bindMethods(this, {
            getCapabilities: invoiceModuleEndpoints.getModule.getCapabilities,
            getCFDIList: invoiceModuleEndpoints.getModule.getCFDIList,
            getCFDIPreview: invoiceModuleEndpoints.getModule.getCFDIPreview,
            downloadCFDIPDF: invoiceModuleEndpoints.getModule.downloadCFDIPDF,
            downloadCFDIZIP: invoiceModuleEndpoints.getModule.downloadCFDIZIP,
            sendCFDIByEmail: invoiceModuleEndpoints.getModule.sendCFDIByEmail,
            getCFDIProductCatalogs: invoiceModuleEndpoints.getModule.getCFDIProductCatalogs,
            createCFDI: invoiceModuleEndpoints.postModule.createCFDI,
            searchGlobalByPaymentMethodCandidates: invoiceModuleEndpoints.postModule.searchGlobalByPaymentMethodCandidates,
            previewGlobalByPaymentMethodCFDI: invoiceModuleEndpoints.postModule.previewGlobalByPaymentMethodCFDI,
            createGlobalByPaymentMethodCFDI: invoiceModuleEndpoints.postModule.createGlobalByPaymentMethodCFDI,
            cancelCFDI: invoiceModuleEndpoints.deleteModule.cancelCFDI,
        });
        this.review = bindMethods(this, {
            getList: reviewsEndpoints.getModule.getList,
            requestStoreReviewByCustomerId: reviewsEndpoints.getModule.requestStoreReviewByCustomerId,
        });
        this.routes = bindMethods(this, {
            getOrdersForRoute: routesEndpoints.getModule.getOrdersForRoute,
            getStoreRoutesList: routesEndpoints.getModule.getStoreRoutesList,
            createRoute: routesEndpoints.postModule.createRoute,
            closeStoreRoutes: routesEndpoints.putModule.closeStoreRoutes,
            //NEW V2 ENDPOINTS
            getRoutesByStore: routesEndpoints.getModule.getRoutesByStore,
            createRouteV2: routesEndpoints.postModule.createRouteV2,
            getRouteByIdV2: routesEndpoints.getModule.getRouteByIdV2,
            getClosePreview: routesEndpoints.getModule.getClosePreview,
            deleteRouteById: routesEndpoints.deleteModule.deleteRouteById,
            closeRouteById: routesEndpoints.putModule.closeRouteById,
            closeRouteByIdV2: routesEndpoints.putModule.closeRouteByIdV2,
            updateRouteById: routesEndpoints.putModule.updateRouteById,
            getRoutesByDriver: routesEndpoints.getModule.getRoutesByDriver,
            getRoutes: routesEndpoints.getModule.getRoutes,
            getRoutesPage: routesEndpoints.getModule.getRoutesPage,
            getRoutesByStorePage: routesEndpoints.getModule.getRoutesByStorePage,
            startRoute: routesEndpoints.postModule.startRoute,
            reorderRouteOrders: routesEndpoints.patchModule.reorderRouteOrders,
        });
        this.publics = bindMethods(this, {
            getOrderPublicReceipt: publicsEndpoints.getModule.getOrderPublicReceipt,
            getPosAppConfig: publicsEndpoints.getModule.getPosAppConfig,
            getHubAppConfig: publicsEndpoints.getModule.getHubAppConfig,
        });
        this.websiteBuilder = bindMethods(this, {
            getSettings: websiteBuilderEndpoints.getModule.getSettings,
            getTemplates: websiteBuilderEndpoints.getModule.getTemplates,
            updateSettings: websiteBuilderEndpoints.putModule.updateSettings,
            getPublicBootstrap: websiteBuilderEndpoints.getModule.getPublicBootstrap,
            getPublicPricingCatalog: websiteBuilderEndpoints.getModule.getPublicPricingCatalog,
            getCompanyWebsiteOrderConfig: websiteBuilderEndpoints.getModule.getCompanyWebsiteOrderConfig,
            getCompanyWebsitePublicStoreSettings: websiteBuilderEndpoints.getModule.getCompanyWebsitePublicStoreSettings,
            getCompanyWebsitePublicSections: websiteBuilderEndpoints.getModule.getCompanyWebsitePublicSections,
            getCompanyWebsitePublicProduct: websiteBuilderEndpoints.getModule.getCompanyWebsitePublicProduct,
            getCompanyWebsitePublicPickupSchedule: websiteBuilderEndpoints.getModule.getCompanyWebsitePublicPickupSchedule,
            createCompanyWebsiteOrder: websiteBuilderEndpoints.postModule.createCompanyWebsiteOrder,
        });
        this.companyMedia = bindMethods(this, {
            getAssets: companyMediaEndpoints.getModule.getAssets,
            createAsset: companyMediaEndpoints.postModule.createAsset,
            updateAsset: companyMediaEndpoints.patchModule.updateAsset,
            deleteAsset: companyMediaEndpoints.deleteModule.deleteAsset,
        });
        this.auth = bindMethods(this, {
            getSessions: authEndpoints.getModule.getSessions,
            revokeSession: authEndpoints.postModule.revokeSession,
            revokeOtherSessions: authEndpoints.postModule.revokeOtherSessions,
            customerLoginToken: authEndpoints.postModule.customerLoginToken,
            googleLogin: authEndpoints.postModule.googleLogin,
            appleLogin: authEndpoints.postModule.appleLogin,
            facebookLogin: authEndpoints.postModule.facebookLogin,
            customerRegularLogin: authEndpoints.postModule.customerRegularLogin,
            customerSignUp: authEndpoints.postModule.customerSignUp,
            customerWebsiteSocialLoginExchange: authEndpoints.postModule.customerWebsiteSocialLoginExchange,
            regularUserLogin: authEndpoints.postModule.regularUserLogin,
            pinLogin: authEndpoints.postModule.pinLogin,
            regularUserTokenLogin: authEndpoints.postModule.regularUserTokenLogin,
            forgotPassword: authEndpoints.postModule.forgotPassword,
            customersAppForgotPassword: authEndpoints.postModule.customersAppForgotPassword,
            customersAppChangePassword: authEndpoints.postModule.customersAppChangePassword,
            companySignUp: authEndpoints.postModule.companySignUp,
            getSignupCountrySuggestion: authEndpoints.getModule.getSignupCountrySuggestion,
        });
        this.orders = bindMethods(this, {
            getList: ordersEndpoints.getModule.getList,
            getOrdersHeaderSummary: ordersEndpoints.getModule.getOrdersHeaderSummary,
            getById: ordersEndpoints.getModule.getById,
            getReturnOrders: ordersEndpoints.getModule.getReturnOrders,
            fetchOrdersForCFDI: ordersEndpoints.getModule.fetchOrdersForCFDI,
            updateById: ordersEndpoints.putModule.updateById,
            updatePaymentLineById: ordersEndpoints.putModule.updatePaymentLineById,
            setOrderCancelledBySequence: ordersEndpoints.putModule.setOrderCancelledBySequence,
            setOrderCleaningBySequence: ordersEndpoints.putModule.setOrderCleaningBySequence,
            setOrderCleanedBySequence: ordersEndpoints.putModule.setOrderCleanedBySequence,
            setOrderCollectedBySequence: ordersEndpoints.putModule.setOrderCollectedBySequence,
            setOrdePickingBySequence: ordersEndpoints.putModule.setOrdePickingBySequence,
            setOrdeDeliveringBySequence: ordersEndpoints.putModule.setOrdeDeliveringBySequence,
            setOrdeDeliveredBySequence: ordersEndpoints.putModule.setOrdeDeliveredBySequence,
            createPaymentLine: ordersEndpoints.postModule.createPaymentLine,
            sendEmailReceipt: ordersEndpoints.postModule.sendEmailReceipt,
            getNotificationOptions: ordersEndpoints.getModule.getNotificationOptions,
            resendNotification: ordersEndpoints.postModule.resendNotification,
            createOrderCustomersApp: ordersEndpoints.postModule.createOrderCustomersApp,
            createOrderUsersApp: ordersEndpoints.postModule.createOrderUsersApp,
            createReturnOrder: ordersEndpoints.postModule.createReturnOrder,
            bulkCreatePaymentLines: ordersEndpoints.postModule.bulkCreatePaymentLines,
            createOrderEvidence: ordersEndpoints.postModule.createOrderEvidence,
            getRedeemPointsPreview: ordersEndpoints.postModule.getRedeemPointsPreview,
            setOrderUncollected: ordersEndpoints.postModule.setOrderUncollected,
            payAndCollect: ordersEndpoints.postModule.payAndCollect,
            sendOrderUncollectedCustomerNotification: ordersEndpoints.postModule.sendOrderUncollectedCustomerNotification,
            recordFailedServiceAttempt: ordersEndpoints.postModule.recordFailedServiceAttempt,
            previewStoreTransfer: ordersEndpoints.postModule.previewStoreTransfer,
            transferStore: ordersEndpoints.postModule.transferStore,
            deletePaymentLineById: ordersEndpoints.deleteModule.deletePaymentLineById,
            deleteOrderEvidence: ordersEndpoints.deleteModule.deleteOrderEvidence,
            getListCustomersApp: ordersEndpoints.getModule.getListCustomersApp,
            getByIdCustomersApp: ordersEndpoints.getModule.getByIdCustomersApp,
            setOrderAcceptedBySequence: ordersEndpoints.putModule.setOrderAcceptedBySequence,
            getRequestedOrdersSummary: ordersEndpoints.getModule.getRequestedOrdersSummary,
            bulkCancel: ordersEndpoints.putModule.bulkCancel,
            bulkClean: ordersEndpoints.putModule.bulkClean,
            bulkCollect: ordersEndpoints.putModule.bulkCollect,
            cancelOrderByIdCustomersApp: ordersEndpoints.deleteModule.cancelOrderByIdCustomersApp,
            updateLineStatuses: ordersEndpoints.patchModule.updateLineStatuses,
            updateLineAssignments: ordersEndpoints.patchModule.updateLineAssignments,
        });
        this.customers = bindMethods(this, {
            getCustomers: customersEndpoints.getModule.getList,
            getCustomerById: customersEndpoints.getModule.getCustomerById,
            getCustomerHighlightsById: customersEndpoints.getModule.getCustomerHighlightsById,
            getCustomerOrders: customersEndpoints.getModule.getCustomerOrders,
            getCustomerByIdCustomersApp: customersEndpoints.getModule.getCustomerByIdCustomersApp,
            getCustomerLoyaltyHistory: customersEndpoints.getModule.getCustomerLoyaltyHistory,
            create: customersEndpoints.postModule.create,
            bulkCreate: customersEndpoints.postModule.bulkCreate,
            updateById: customersEndpoints.putModule.updateById,
            deleteById: customersEndpoints.deleteModule.deleteById,
            deleteByIdCustomersApp: customersEndpoints.deleteModule.deleteByIdCustomersApp,
            updateByIdCustomersApp: customersEndpoints.putModule.updateByIdCustomersApp,
            updateAddressCustomersApp: customersEndpoints.patchModule.updateAddressCustomersApp,
        });
        this.stores = bindMethods(this, {
            getStores: getStores,
            getStoreById: getStoreById,
            getStoreImages: getStoreImages,
            getStoresByName: getStoresByName,
            getStoresByIdCustomersApp: getStoresByIdCustomersApp,
            getPickupScheduleCustomersApp: getPickupScheduleCustomersApp,
            createStore: createStore,
            copyStore: copyStore,
            copyLoyaltySettings: copyLoyaltySettings,
            updateStoreById: updateStoreById,
            createStoreImage: createStoreImage,
            getStoreReviewLink: getStoreReviewLink,
            deleteStoreById: deleteStoreById,
            getOrderSequence: getOrderSequence,
            setOrderSequence: setOrderSequence,
            getPaymentFees: getPaymentFees,
            updatePaymentFees: updatePaymentFees,
        });
        this.products = bindMethods(this, {
            getById: productsEndpoints.getModule.getById,
            getByIdCustomersApp: productsEndpoints.getModule.getByIdCustomersApp,
            getProductSupplies: productsEndpoints.getModule.getProductSupplies,
            create: productsEndpoints.postModule.create,
            createProductSupply: productsEndpoints.postModule.createProductSupply,
            bulkCreate: productsEndpoints.postModule.bulkCreate,
            deleteById: productsEndpoints.deleteModule.deleteById,
            deleteProductSupplyById: productsEndpoints.deleteModule.deleteProductSupplyById,
            updateById: productsEndpoints.putModule.updateById,
            bulkImport: productsEndpoints.putModule.bulkImport,
            bulkUpdate: productsEndpoints.putModule.bulkUpdate,
            createPriceOption: productsEndpoints.postModule.createPriceOption,
            bulkUpdateProductPrices: productsEndpoints.postModule.bulkUpdateProductPrices,
            updatePriceOption: productsEndpoints.putModule.updatePriceOption,
            deletePriceOption: productsEndpoints.deleteModule.deletePriceOption,
        });
        this.users = bindMethods(this, {
            updateUserById: updateUserById,
            updatePushNotificationTokenDriversApp: updatePushNotificationTokenDriversApp,
            getUserStoreAccess: getUserStoreAccess,
            deleteUserById: deleteUserById,
            validateUserPin: validateUserPin,
        });
        this.countries = bindMethods(this, {
            getCountries: getCountries,
        });
        this.config = bindMethods(this, {
            getTaxPresets: configEndpoints.getModule.getTaxPresets,
        });
        this.googleMaps = bindMethods(this, {
            autocompleteCustomersApp: googleMapsEndpoints.postModule.autocompleteCustomersApp,
            placeDetailsCustomersApp: googleMapsEndpoints.postModule.placeDetailsCustomersApp,
            geocodeCustomersApp: googleMapsEndpoints.postModule.geocodeCustomersApp,
            reverseGeocodeCustomersApp: googleMapsEndpoints.postModule.reverseGeocodeCustomersApp,
            autocomplete: googleMapsEndpoints.postModule.autocomplete,
            placeDetails: googleMapsEndpoints.postModule.placeDetails,
            geocode: googleMapsEndpoints.postModule.geocode,
            reverseGeocode: googleMapsEndpoints.postModule.reverseGeocode,
        });
        this.supplies = bindMethods(this, {
            getSupplies: getSupplies,
            getSupplyById: getSupplyById,
            getSupplyHistory: getSupplyHistory,
            createSupply: createSupply,
            updateSupplyById: updateSupplyById,
            addSupplyStock: addSupplyStock,
            deleteSupplyById: deleteSupplyById,
        });
        this.sections = bindMethods(this, {
            getSections: sectionsEndpoints.getModule.getList,
            getById: sectionsEndpoints.getModule.getById,
            getSubcategories: sectionsEndpoints.getModule.getSubcategories,
            getSectionsByStoreCustomersApp: sectionsEndpoints.getModule.getSectionsByStoreCustomersApp,
            create: sectionsEndpoints.postModule.create,
            copy: sectionsEndpoints.postModule.copy,
            createSubcategory: sectionsEndpoints.postModule.createSubcategory,
            updateSubcategory: sectionsEndpoints.patchModule.updateSubcategory,
            deleteSubcategory: sectionsEndpoints.deleteModule.deleteSubcategory,
            deleteById: sectionsEndpoints.deleteModule.deleteById,
            updateById: sectionsEndpoints.putModule.updateById,
        });
        this.inventory = bindMethods(this, {
            getInventory: inventoryEndpoints.getModule.getInventory,
            getById: inventoryEndpoints.getModule.getInventoryById,
            getHistoryById: inventoryEndpoints.getModule.getHistoryById,
            create: inventoryEndpoints.postModule.create,
            deleteById: inventoryEndpoints.deleteModule.deleteById,
            updateById: inventoryEndpoints.putModule.updateById,
            addStock: inventoryEndpoints.putModule.addStock,
        });
        this.cashierboxes = bindMethods(this, {
            getCashierboxesByStoreId: getCashierboxesByStoreId,
            getCashierboxesById: getCashierboxesById,
            getCashierBoxMovementsHistory: getCashierBoxMovementsHistory,
            createCashierBox: createCashierBox,
            updateCashierBoxById: updateCashierBoxById,
            updateCashierBoxMovementById: updateCashierBoxMovementById,
            deleteCashierBoxById: deleteCashierBoxById,
            addCashierBoxMovement: addCashierBoxMovement,
            deleteCashierBoxMovementById: deleteCashierBoxMovementById,
        });
        this.companies = bindMethods(this, {
            getSubscriptionBillingStatus: getSubscriptionBillingStatus,
            getCompanyById: getCompanyById,
            getCompanyOrdersMetrics: getCompanyOrdersMetrics,
            getGarmentAttributeCatalogs: getGarmentAttributeCatalogs,
            updateCompanyById: updateCompanyById,
            updateCompanyLogoById: updateCompanyLogoById,
            updateCompanySubscriptionBillingInfoById: updateCompanySubscriptionBillingInfoById,
            updateCompanyTaxInfoById: updateCompanyTaxInfoById,
            updateGarmentAttributeCatalogsById: updateGarmentAttributeCatalogsById,
            updateCompanyTaxInfoCertificates: updateCompanyTaxInfoCertificates,
            updateCFDIOrgLogo: updateCFDIOrgLogo,
            enableBillingOverage: enableBillingOverage,
            disableBillingOverage: disableBillingOverage,
            enableCFDIAddon: enableCFDIAddon,
            disableCFDIAddon: disableCFDIAddon,
            getCFDIAddonStatus: getCFDIAddonStatus,
            getAvailableSubscriptionPlans: getAvailableSubscriptionPlans,
            getAvailableBillingExtraPackages: getAvailableBillingExtraPackages,
            previewSubscriptionPlanChange: previewSubscriptionPlanChange,
            changeSubscriptionPlan: changeSubscriptionPlan,
            previewCatalogConsolidation: previewCatalogConsolidation,
            applyCatalogConsolidation: applyCatalogConsolidation,
        });
        this.stripe = bindMethods(this, {
            createCreateSuscriptionCheckoutSession: createCreateSuscriptionCheckoutSession,
            createCFDISuscrptionCheckoutSession: createCFDISuscrptionCheckoutSession,
            createGetMoreCheckoutSession: createGetMoreCheckoutSession,
            createCustomerPortalSession: createCustomerPortalSession
        });
        this.staff = bindMethods(this, {
            getStoreStaff: getStoreStaff,
            getStoreAssignableStaffs: getStoreAssignableStaffs,
            getStoreStaffById: getStoreStaffById,
            updateStoreStaffById: updateStoreStaffById,
            updateStoreStaffStores: updateStoreStaffStores,
            createStoreStaff: createStoreStaff,
            deleteStoreStaffById: deleteStoreStaffById,
        });
        this.discountCodes = bindMethods(this, {
            getDiscountCodes: getDiscountCodes,
            getDiscountCodeById: getDiscountCodeById,
            verifyDiscountCode: verifyDiscountCode,
            verifyDiscountCodeCustomersApp: verifyDiscountCodeCustomersApp,
            createDiscountCode: createDiscountCode,
            deleteDiscountCodeById: deleteDiscountCodeById,
            updateDiscountCodeById: updateDiscountCodeById,
        });
        this.automaticDiscount = bindMethods(this, {
            getAutomaticDiscounts: getAutomaticDiscounts,
            getAvailableAutomaticDiscounts: getAvailableAutomaticDiscounts,
            getAutomaticDiscountById: getAutomaticDiscountById,
            createAutomaticDiscount: createAutomaticDiscount,
            deleteAutomaticDiscountById: deleteAutomaticDiscountById,
            updateAutomaticDiscountById: updateAutomaticDiscountById,
        });
        const csvMethods = bindMethods(this, {
            exportCustomersList: csvExportEndpoints.getModule.exportCustomersList,
            exportOrdersList: csvExportEndpoints.getModule.exportOrdersList,
            exportProductsList: csvExportEndpoints.getModule.exportProductsList,
            exportCleanedOrdersReport: csvExportEndpoints.getModule.exportCleanedOrdersReport,
            exportSalesReport: csvExportEndpoints.getModule.exportSalesReport,
            exportCustomersReport: csvExportEndpoints.getModule.exportCustomersReport,
            exportSuppliesReport: csvExportEndpoints.getModule.exportSuppliesReport,
            exportDiscountCodesReport: csvExportEndpoints.getModule.exportDiscountCodesReport,
            exportStaffReport: csvExportEndpoints.getModule.exportStaffReport,
            exportProductSalesReport: csvExportEndpoints.getModule.exportProductSalesReport,
            exportPaymentLinesReport: csvExportEndpoints.getModule.exportPaymentLinesReport,
            exportOutsourcingReport: csvExportEndpoints.getModule.exportOutsourcingReport,
            exportCashierBoxMovementsReport: csvExportEndpoints.getModule.exportCashierBoxMovementsReport,
            exportUnpaidOrdersReportCSV: csvExportEndpoints.getModule.exportUnpaidOrdersReportCSV,
            exportAttendanceReport: csvExportEndpoints.getModule.exportAttendanceReport,
            exportCashUpReportsByDateRange: csvExportEndpoints.getModule.exportCashUpReportsByDateRange,
            exportScheduledDeliveriesReport: csvExportEndpoints.getModule.exportScheduledDeliveriesReport,
            exportServicesToDeliverReport: csvExportEndpoints.getModule.exportServicesToDeliverReport,
        });
        this.csv = Object.assign(Object.assign({}, csvMethods), { exportOrdersHistoryReport: csvExportEndpoints.getModule.exportOrdersHistoryReport.bind(this) });
        this.pdf = bindMethods(this, {
            exportUnpaidOrdersReportPDF: pdfExportEndpoints.getModule.exportUnpaidOrdersReportPDF,
        });
        this.reports = bindMethods(this, {
            getFinancialSummary: reportsExportEndpoints.getModule.getFinancialSummary,
            getCashUpReportsByDateRange: reportsExportEndpoints.getModule.getCashUpReportsByDateRange,
            getCleanedOrdersReport: reportsExportEndpoints.getModule.getCleanedOrdersReport,
            getCleanedOrdersGraphDataReport: reportsExportEndpoints.getModule.getCleanedOrdersGraphDataReport,
            getSalesReport: reportsExportEndpoints.getModule.getSalesReport,
            getCustomersReport: reportsExportEndpoints.getModule.getCustomersReport,
            getSuppliesReport: reportsExportEndpoints.getModule.getSuppliesReport,
            getDiscountCodesReport: reportsExportEndpoints.getModule.getDiscountCodesReport,
            getStaffReport: reportsExportEndpoints.getModule.getStaffReport,
            getStaffActivityDetails: reportsExportEndpoints.getModule.getStaffActivityDetails,
            getProductSalesReport: reportsExportEndpoints.getModule.getProductSalesReport,
            getProductSalesDrillDown: reportsExportEndpoints.getModule.getProductSalesDrillDown,
            getPaymentLinesReport: reportsExportEndpoints.getModule.getPaymentLinesReport,
            getCashierBoxMovementsReport: reportsExportEndpoints.getModule.getCashierBoxMovementsReport,
            getUnpaidOrdersReport: reportsExportEndpoints.getModule.getUnpaidOrdersReport,
            getScheduledDeliveries: reportsExportEndpoints.getModule.getScheduledDeliveries,
            getServicesToDeliver: reportsExportEndpoints.getModule.getServicesToDeliver,
            getOrdersHistoryReport: reportsExportEndpoints.getModule.getOrdersHistoryReport,
            getAnnualSalesStatistics: reportsExportEndpoints.getModule.getAnnualSalesStatistics,
            getPaymentMethodStatistics: reportsExportEndpoints.getModule.getPaymentMethodStatistics,
            getProductsStatistics: reportsExportEndpoints.getModule.getProductsStatistics,
            getMonthSalesStatistics: reportsExportEndpoints.getModule.getMonthSalesStatistics,
            getPopularDaysStatistics: reportsExportEndpoints.getModule.getPopularDaysStatistics,
            getSupplyCostReport: reportsExportEndpoints.getModule.getSupplyCostReport,
            exportSupplyCostReport: reportsExportEndpoints.getModule.exportSupplyCostReport,
        });
        this.partners = bindMethods(this, {
            getPartners: partnersEndpoints.getModule.getPartners,
            getPartnerById: partnersEndpoints.getModule.getPartnerById,
            createPartner: partnersEndpoints.postModule.createPartner,
            updatePartnerById: partnersEndpoints.putModule.updatePartnerById,
            deletePartnerById: partnersEndpoints.deleteModule.deletePartnerById,
        });
        this.outsourcedOrders = bindMethods(this, {
            getOutsourcedOrdersByOrder: outsourcedOrdersEndpoints.getModule.getOutsourcedOrdersByOrder,
            getOutsourcedOrdersByStore: outsourcedOrdersEndpoints.getModule.getOutsourcedOrdersByStore,
            getOutsourcedOrderById: outsourcedOrdersEndpoints.getModule.getOutsourcedOrderById,
            createOutsourcedOrder: outsourcedOrdersEndpoints.postModule.createOutsourcedOrder,
            updateOutsourcedOrderById: outsourcedOrdersEndpoints.putModule.updateOutsourcedOrderById,
            deleteOutsourcedOrderById: outsourcedOrdersEndpoints.deleteModule.deleteOutsourcedOrderById,
        });
        this.attendance = bindMethods(this, {
            getHistory: attendanceEndpoints.getModule.getHistory,
            getStatus: attendanceEndpoints.getModule.getStatus,
            getStoreReport: attendanceEndpoints.getModule.getStoreReport,
            exportStoreReport: attendanceEndpoints.getModule.exportStoreReport,
            clockIn: attendanceEndpoints.postModule.clockIn,
            clockOut: attendanceEndpoints.postModule.clockOut,
            updateById: attendanceEndpoints.putModule.updateById,
        });
        this.integrations = Object.assign(Object.assign({}, bindMethods(this, {
            getMPConnectionStatus: integrationsEndpoints.getModule.getMPConnectionStatus,
            startMPOAuthFlow: integrationsEndpoints.postModule.startMPOAuthFlow,
        })), { mercadoPago: bindMethods(this, {
                getDiscoverMPTerminals: integrationsEndpoints.getModule.getDiscoverMPTerminals,
                importMPTerminal: integrationsEndpoints.postModule.importMPTerminal,
                getStoredMPTerminals: integrationsEndpoints.getModule.getStoredMPTerminals,
                disconnectMP: integrationsEndpoints.postModule.disconnectMP,
                getMPUsersStores: integrationsEndpoints.getModule.getMPUsersStores,
                importAllMPTerminals: integrationsEndpoints.postModule.importAllMPTerminals,
                createMPAttempt: integrationsEndpoints.postModule.createMPAttempt,
                cancelMPAttempt: integrationsEndpoints.postModule.cancelMPAttempt,
                getMPAttemptStatus: integrationsEndpoints.getModule.getMPAttemptStatus,
                updateMPTerminalOperationMode: integrationsEndpoints.postModule.updateMPTerminalOperationMode,
            }) });
        this.productFeedback = bindMethods(this, {
            create: productFeedbackEndpoints.postModule.create,
        });
        this.productSurveys = bindMethods(this, {
            getActive: productSurveysEndpoints.getModule.getActive,
            participate: productSurveysEndpoints.postModule.participate,
        });
        this.updates = bindMethods(this, {
            getLatestUpdates: updatesEndpoints.getModule.getLatestUpdates,
            markUpdatesAsSeen: updatesEndpoints.postModule.markUpdatesAsSeen,
        });
        this.intercom = bindMethods(this, {
            getMessengerToken: intercomEndpoints.postModule.getMessengerToken,
        });
    }
}
export default WashdayClient;
